/**
 * The attributes parameter is the existing attributes on the stored user. This is necessary to
 * maintain attributes when hot reloading.
 */
const getOptimizelyAttributes = (search: string, attributes: Record<string, any> = {}) => {
  const searchParams = new URLSearchParams(search);

  searchParams.forEach((value, key) => {
    if (/^opt_/.test(key)) {
      const attribute = key.replace(/^opt_/, '');

      attributes[attribute] = value;
    }
  });

  return attributes;
};

export default getOptimizelyAttributes;
